import React, { useState, useEffect } from "react";
import CVLayout from "./components/CVLayout";

// Import CSS
import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "./components/styles.css";
import "./components/CVLayout.css";

function CVApp() {
  // Dark mode state management with localStorage persistence
  const [darkTheme, setDarkTheme] = useState(() => {
    const savedTheme = localStorage.getItem('darkTheme');
    return savedTheme ? JSON.parse(savedTheme) : true; // Default to dark mode
  });

  const toggleDarkMode = () => {
    const newTheme = !darkTheme;
    setDarkTheme(newTheme);
    localStorage.setItem('darkTheme', JSON.stringify(newTheme));
  };

  useEffect(() => {
    // Set page title for CV
    document.title = 'CV - Facundo Criscuolo';
    
    // Set dark theme class on body
    if (darkTheme) {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  }, [darkTheme]);

  return (
    <div className={`cv-app ${darkTheme ? "dark-theme" : ""}`}>
      <CVLayout 
        darkTheme={darkTheme} 
        toggleDarkMode={toggleDarkMode}
      />
    </div>
  );
}

export default CVApp;